<template>
  <div class="device-management">
    <el-card v-if="!isLoggedIn" class="box-card login-card">
      <div slot="header" class="clearfix">
        <span>用户登录</span>
      </div>

      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        label-width="80px"
        @submit.native.prevent
      >
        <el-form-item label="账号" prop="userName">
          <el-input
            v-model.trim="loginForm.userName"
            placeholder="请输入账号"
            clearable
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <div class="submit-section">
          <el-button type="primary" :loading="loggingIn" @click="handleLogin">
            登录
          </el-button>
        </div>
      </el-form>
    </el-card>

    <el-card v-else class="box-card">
      <div slot="header" class="clearfix">
        <span>订阅</span>
      </div>

      <!-- <div class="status-section">
        <h5>微信信息：</h5>
        <div class="debug-text">code：{{ code || '未获取到code' }}</div>
        <div class="debug-text">openId：{{ openId || (openIdLoading ? '获取中...' : '未获取到openId') }}</div>
      </div> -->

      <div class="status-section" style="margin-top: 20px">
        <h5>选择网关：</h5>
        <el-select
          v-model="selectedGatewayId"
          placeholder="请选择网关"
          :loading="gatewayLoading"
          @change="handleGatewayChange"
        >
          <el-option
            v-for="item in gatewayList"
            :key="getGatewayId(item)"
            :label="getGatewayLabel(item)"
            :value="getGatewayId(item)"
          />
        </el-select>
      </div>

      <div class="status-section" style="margin-top: 20px">
        <h5>选择设备：</h5>
        <el-radio-group v-model="selectedDeviceId">
          <el-radio
            v-for="item in deviceList"
            :key="getDeviceId(item)"
            :label="getDeviceId(item)"
          >
            {{ getDeviceLabel(item) }}
          </el-radio>
        </el-radio-group>
        <el-empty
          v-if="!deviceLoading && deviceList.length === 0"
          description="暂无设备"
          :image-size="80"
        />
      </div>

      <div class="status-section" style="margin-top: 20px">
        <h5>选择状态：</h5>
        <el-checkbox-group v-model="selectedStatuses">
          <el-checkbox :label="1">大便</el-checkbox>
          <el-checkbox :label="2">小便</el-checkbox>
          <!-- <el-checkbox :label="7">放屁</el-checkbox> -->
        </el-checkbox-group>
      </div>

      <div class="submit-section" style="margin-top: 30px">
        <el-button type="primary" @click="submitData" :loading="submitting">
          提交
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

const DIAPER_API_BASE_URL = 'https://fourleafpy.feelt-sport.com'

export default {
  name: 'DeviceManagement',
  data() {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      loginRules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loggingIn: false,
      isLoggedIn: false,
      userId: '',
      gatewayLoading: false,
      deviceLoading: false,
      gatewayList: [],
      selectedGatewayId: '',
      deviceList: [],
      selectedDeviceId: '',
      selectedStatuses: [],
      submitting: false,
      code: '',
      openIdLoading: false,
      openId: ''
    }
  },
  created() {
    this.getCodeFromUrl()
    this.fetchWechatOpenId()
  },
  methods: {
    getCodeFromUrl() {
      const urlParams = new URLSearchParams(window.location.search)
      const routeQuery = this.$route && this.$route.query ? this.$route.query : {}
      this.code = routeQuery.code ||
        urlParams.get('code') ||
        ''
      if (!this.code) {
        this.$message.warning('URL中没有找到code参数')
      }
    },

    async fetchWechatOpenId() {
      if (!this.code) {
        return
      }

      this.openIdLoading = true
      try {
        const response = await axios.post(
          `${DIAPER_API_BASE_URL}/diaper/getWechatOpenId`,
          { code: this.code },
          this.getJsonConfig()
        )

        if (response.data && response.data.result === true) {
          this.openId = response.data.data && response.data.data.openId
          if (!this.openId) {
            this.$message.error('获取openId成功但未返回openId')
          }
        } else {
          this.$message.error((response.data && response.data.msg) || '获取openId失败')
        }
      } catch (error) {
        console.error('获取openId失败:', error)
        this.$message.error('网络错误，获取openId失败')
      } finally {
        this.openIdLoading = false
      }
    },

    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) {
          return
        }

        this.loggingIn = true
        try {
          const response = await axios.post(
            `${DIAPER_API_BASE_URL}/diaper/user_login`,
            {
              userName: this.loginForm.userName,
              password: this.loginForm.password
            },
            this.getJsonConfig()
          )

          if (response.data && response.data.result === true) {
            this.userId = response.data.data && response.data.data.id
            if (!this.userId) {
              this.$message.error('登录成功但未返回用户ID')
              return
            }

            this.isLoggedIn = true
            this.$message.success('登录成功')
            await this.fetchGatewayList()
          } else {
            this.$message.error((response.data && response.data.msg) || '登录失败')
          }
        } catch (error) {
          console.error('登录失败:', error)
          this.$message.error('网络错误，登录失败')
        } finally {
          this.loggingIn = false
        }
      })
    },

    async fetchGatewayList() {
      if (!this.userId) {
        return
      }

      this.gatewayLoading = true
      try {
        const response = await axios.post(
          `${DIAPER_API_BASE_URL}/diaper/getGateWayListFromUser`,
          { userId: this.userId },
          this.getJsonConfig()
        )

        if (response.data && response.data.result === true) {
          this.gatewayList = Array.isArray(response.data.data) ? response.data.data : []
          this.selectedGatewayId = this.gatewayList.length > 0
            ? this.getGatewayId(this.gatewayList[0])
            : ''

          if (this.selectedGatewayId) {
            await this.fetchDeviceList(this.selectedGatewayId)
          } else {
            this.deviceList = []
            this.selectedDeviceId = ''
            this.$message.warning('当前用户暂无网关')
          }
        } else {
          this.$message.error((response.data && response.data.msg) || '获取网关列表失败')
        }
      } catch (error) {
        console.error('获取网关列表失败:', error)
        this.$message.error('网络错误，获取网关列表失败')
      } finally {
        this.gatewayLoading = false
      }
    },

    handleGatewayChange(gateWayId) {
      this.fetchDeviceList(gateWayId)
    },

    async fetchDeviceList(gateWayId) {
      if (!gateWayId) {
        this.deviceList = []
        this.selectedDeviceId = ''
        return
      }

      this.deviceLoading = true
      this.selectedDeviceId = ''
      try {
        const response = await axios.post(
          `${DIAPER_API_BASE_URL}/diaper/getDeviceListFromGatewayId`,
          { gateWayId },
          this.getJsonConfig()
        )

        if (response.data && response.data.result === true) {
          this.deviceList = Array.isArray(response.data.data) ? response.data.data : []
        } else {
          this.deviceList = []
          this.$message.error((response.data && response.data.msg) || '获取设备列表失败')
        }
      } catch (error) {
        console.error('获取设备列表失败:', error)
        this.deviceList = []
        this.$message.error('网络错误，获取设备列表失败')
      } finally {
        this.deviceLoading = false
      }
    },

    async submitData() {
      if (!this.selectedDeviceId) {
        this.$message.warning('请至少选择一个设备')
        return
      }

      if (!this.selectedGatewayId) {
        this.$message.warning('请先选择网关')
        return
      }

      if (this.selectedStatuses.length === 0) {
        this.$message.warning('请至少选择一个状态')
        return
      }

      if (!this.openId) {
        this.$message.warning('缺少openId')
        return
      }

      const postData = {
        types: this.selectedStatuses,
        deviceId: this.selectedDeviceId,
        gateWayId: this.selectedGatewayId,
        openId: this.openId
      }

      this.submitting = true

      try {
        const response = await axios.post(
          `${DIAPER_API_BASE_URL}/diaper/add_subcribeUserLevels`,
          postData,
          this.getJsonConfig()
        )

        if (response.data && response.data.result === true) {
          this.$message.success('提交成功')
          console.log('提交成功:', response.data)
        } else {
          this.$message.error((response.data && (response.data.msg || response.data.message)) || '提交失败')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('网络错误，提交失败')
      } finally {
        this.submitting = false
      }
    },

    getJsonConfig() {
      return {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    },

    getGatewayId(item) {
      return item.gateWayId || item.gatewayId || item.GateWayId || item.id || ''
    },

    getGatewayLabel(item) {
      const gateWayId = this.getGatewayId(item)
      return item.gateWayName || item.gatewayName || item.name || gateWayId
    },

    getDeviceId(item) {
      return item.deviceId || item.diaperDeviceId || item.id || ''
    },

    getDeviceLabel(item) {
      const deviceId = this.getDeviceId(item)
      const deviceName = item.deviceName ? item.deviceName+"_" : ""
      return deviceName+deviceId || deviceName+item.name || deviceName+deviceId
    }
  }
}
</script>

<style scoped>
.device-management {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.box-card {
  margin-bottom: 20px;
  font-size: 20px;
}

.login-card {
  max-width: 480px;
  margin: 60px auto 0;
}

.status-section {
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.openid-section {
  padding: 12px 15px;
  margin-bottom: 20px;
  line-height: 1.8;
  word-break: break-all;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.debug-text {
  line-height: 1.8;
  word-break: break-all;
}

.submit-section {
  text-align: center;
}
</style>
